import angular from 'angular';

angular.module('cloudX').directive('cxTimeInput', [
  '$parse',
  '$timeout',
  function($parse, $timeout) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        id: '@',
        disabled: '=ngDisabled',
      },
      template:
        '<div class="time-input input-group">' +
        '  <input ondragstart="return false;" ondrop="return false;" id="{{id}}-HourField" type="number" ng-model="time.hour" ng-keydown="onKeyDown($event)" ng-change="valueChanged(true)" ng-disabled="disabled" select-on-focus class="form-control"/>' +
        '  <span class="input-group-addon">:</span>' +
        '  <input ondragstart="return false;" ondrop="return false;" id="{{id}}-MinuteField" type="number" ng-model="time.minute" ng-keydown="onKeyDown($event)" ng-change="valueChanged()" ng-disabled="disabled" select-on-focus class="form-control"/>' +
        '</div>',
      require: 'ngModel',
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        var unit = (attrs.unit || 'm').substring(0, 1).toLowerCase(); //m or h
        if (unit !== 'm' && unit !== 'h') unit = 'm';

        scope.time = {
          hour: 0,
          minute: 0,
        };

        var lastKeyPressWasArrow = false;

        var setValue = function(value) {
          var sign = value < 0 ? -1 : 1;
          if (unit === 'm') {
            scope.time.minute = Math.abs(value) % 60;
            scope.time.hour = sign * Math.floor((Math.abs(value) - scope.time.minute) / 60.0);
          } else {
            scope.time.minute = Math.round(Math.abs(value) * 60) % 60;
            scope.time.hour = sign * Math.floor(Math.abs(value));
          }
        };
        var getValue = function() {
          var sign = scope.time.hour < 0 ? -1 : 1;

          if (unit === 'm')
            return (
              sign *
              ((Math.abs(parseInt(scope.time.hour)) || 0) * 60 + (parseInt(scope.time.minute) || 0))
            );
          return (
            sign *
            ((Math.abs(parseInt(scope.time.hour)) || 0) + (parseInt(scope.time.minute) / 60.0 || 0))
          );
        };

        /**
         * Use e-min & e-max attributes to set a minimum and maximum.
         * Use the e-min="{{value}}" syntax
         */
        var watches = { eMin: null, eMax: null, disabled: null };

        attrs.$observe('eMin', function(value) {
          scope.min = $parse(value);
          if (!!watches.eMin) watches.eMin(); //Destroy old watch
          watches.eMin = scope.$parent.$watch(scope.min, function(newValue) {
            newValue = newValue || 0;
            var value = getValue();
            if (value < newValue) ngModel.$setViewValue(newValue);
            ngModel.$render();
          });
        });
        attrs.$observe('eMax', function(value) {
          scope.max = $parse(value);
          if (!!watches.eMax) watches.eMax(); //Destroy old watch
          watches.eMax = scope.$parent.$watch(scope.max, function(newValue) {
            newValue = newValue || 1439;
            var value = getValue();
            if (value > newValue) ngModel.$setViewValue(newValue);
            ngModel.$render();
          });
        });

        scope.onKeyDown = function(event) {
          if (event.keyCode === 38 || event.keyCode === 40) {
            lastKeyPressWasArrow = true;
          } else {
            lastKeyPressWasArrow = false;
          }
        };

        scope.valueChanged = function(isHoursInput) {
          var value = getValue();
          var max =
            scope.max != null ? scope.max(scope.$parent, scope) : unit === 'm' ? 1439 : 1439 / 60.0; //Default 23:59
          var min = scope.min != null ? scope.min(scope.$parent, scope) : 0; //Default 0

          if (scope.time.minute < 0 || scope.time.minute >= 60) {
            setValue(value);
          }
          if (value < min) {
            value = min;
            setValue(value);
          }
          if (value > max) {
            //Default 23:59
            value = max;
            setValue(value);
          }

          ngModel.$setViewValue(value);

          if (
            isHoursInput &&
            scope.time.hour &&
            // dont shift focus to minute field if the user is using the up/down arrow to increase/decrease hours. This results in bad UX
            !lastKeyPressWasArrow &&
            // use the element selector to get the amount of digits in the input field. The value of the number field is 9 even if the user entered 09.
            // after the 2nd digit, we jump to the minutes field
            document.getElementById(`${scope.id}-HourField`).value.toString().length === 2
          ) {
            $timeout(function() {
              document.getElementById(`${scope.id}-MinuteField`).focus();
            }, 0);
          }
        };

        ngModel.$render = function() {
          if (isNaN(ngModel.$viewValue)) return;
          setValue(Number(ngModel.$viewValue));
        };
      },
    };
  },
]);
